const config = {
  url: '/video-series',
  title: 'Серии видео',
  endpoint: '/admin-search?filter=video_series',
  type: 'table',
  getUrl: id => `/video-one-series/${id}`,
  getApiUrl: id => `/video-series/${id}`,
  search: true,
  key: 'video-series',
  access: ['*'],
  table: [
    {
      key: 'id',
      width: 75,
      title: 'ID',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.id
    },
    {
      key: 'name',
      width: 150,
      title: 'Название',
      sorter: true,
      isViewByDefault: true,
      getValue: data => data.name,
      edit: {
        component: 'Input',
        placeholder: 'Введите',
        maxLength: 255,
        required: true,
      },

    },
  ],
  filters: [],
}

export default config
